import request from '@/utils/request2'

// 列表(主数据列表)
export function loadSchemeListDataApi(data) {
  return request({
    url: 'tms-web/scheme/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportSchemeListDataApi(data) {
  return request({
    url: 'tms-web/scheme/exportByPage',
    method: 'post',
    data
  })
}

// 合计
export function sumSchemeListDataApi(data) {
  return request({
    url: 'tms-web/scheme/sumByPage',
    method: 'post',
    data
  })
}

// 统计方案待办数量
export function countTodoSchemeApi(data) {
  return request({
    url: 'tms-web/scheme/countTodo',
    method: 'post',
    data
  })
}

// 保存
export function saveSchemeApi(data) {
  return request({
    url: 'tms-web/scheme/save',
    method: 'post',
    data
  })
}

// 变更
export function changeSchemeApi(data) {
  return request({
    url: 'tms-web/scheme/change',
    method: 'post',
    data
  })
}

// 审核痕迹化资料
export function auditSchemeApi(data) {
  return request({
    url: 'tms-web/scheme/audit',
    method: 'post',
    data
  })
}

// 更新最大使用数量
export function updateSchemeMaxAmountApi(data) {
  return request({
    url: 'tms-web/scheme/updateMaxAmount',
    method: 'post',
    data
  })
}

// 补充录入物料及服务项目
export function supplementSchemeApi(data) {
  return request({
    url: 'tms-web/scheme/supplement',
    method: 'post',
    data
  })
}

// 复核
export function checkSchemeApi(data) {
  return request({
    url: 'tms-web/scheme/check',
    method: 'post',
    data
  })
}

// 反复核
export function unCheckSchemeApi(data) {
  return request({
    url: 'tms-web/scheme/unCheck',
    method: 'post',
    data
  })
}

// 终止执行
export function stopSchemeApi(data) {
  return request({
    url: 'tms-web/scheme/stop',
    method: 'post',
    data
  })
}

// 结束方案
export function finishSchemeApi(data) {
  return request({
    url: 'tms-web/scheme/finish',
    method: 'post',
    data
  })
}

// 作废
export function deleteSchemeApi(data) {
  return request({
    url: 'tms-web/scheme/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewSchemeApi(data) {
  return request({
    url: 'tms-web/scheme/view',
    method: 'post',
    data
  })
}

// 列表
export function listSchemeApi(data) {
  return request({
    url: 'tms-web/scheme/list',
    method: 'post',
    data
  })
}

// 获取方案活动结束执行情况判断明细
export function loadSchemeExecuteCaseDetailApi(data) {
  return request({
    url: 'tms-web/scheme/loadExecuteCaseDetail',
    method: 'post',
    data
  })
}

// 获取方案活动结束执行情况判断明细
export function loadTraceTemplateDataApi(data) {
  return request({
    url: 'tms-web/scheme/loadTraceTemplateData',
    method: 'post',
    data
  })
}

// 根据ids更新方案设置计算绩效
export function updateSchemeIsPerformanceApi(data) {
  return request({
    url: 'tms-web/scheme/updateIsPerformance',
    method: 'post',
    data
  })
}

// 根据id取消设置计算绩效
export function updateCancelSchemeIsPerformanceApi(data) {
  return request({
    url: 'tms-web/scheme/updateCancelIsPerformance',
    method: 'post',
    data
  })
}


// 下载方案JSON数据
export function downloadSchemeJsonDataApi(data) {
  return request({
    url: 'tms-web/scheme/downloadJsonData',
    method: 'post',
    data
  })
}